export const host = (process.env.NODE_ENV === 'development') ? 'http://localhost:5010/' : window.ENV.REACT_APP_API_URL;